<template>
  <v-row dense>
    <v-col cols="12" class="text-right px-4 pt-4">入金期日: {{ printDue }}&nbsp;発行日: {{ printCharged }}</v-col>
    <v-col cols="12">
      <v-list>
        <v-list-item class="secondary">
          <v-row dense>
            <v-col cols="6" class="text-left white--text">請求内容</v-col>
            <v-col cols="6" class="text-right white--text">計: {{ printTotal }}</v-col>
          </v-row>
        </v-list-item>
        <v-list-item class="">
          <v-row dense>
            <v-col cols="6" class="text-left">学費</v-col>
            <v-col cols="6" class="text-right">{{ printSchool }}</v-col>
          </v-row>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item class="">
          <v-row dense>
            <v-col cols="6" class="text-left">滞在費用</v-col>
            <v-col cols="6" class="text-right">{{ printStay }}</v-col>
          </v-row>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item class="">
          <v-row dense>
            <v-col cols="6" class="text-left">航空券代金</v-col>
            <v-col cols="6" class="text-right">{{ printFlight }}</v-col>
          </v-row>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item class="">
          <v-row dense>
            <v-col cols="6" class="text-left">保険料</v-col>
            <v-col cols="6" class="text-right">{{ printInsurance }}</v-col>
          </v-row>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item class="">
          <v-row dense>
            <v-col cols="6" class="text-left">査証費用</v-col>
            <v-col cols="6" class="text-right">{{ printVisa }}</v-col>
          </v-row>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item class="">
          <v-row dense>
            <v-col cols="6" class="text-left">サポート費用</v-col>
            <v-col cols="6" class="text-right">{{ printSupport }}</v-col>
          </v-row>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item class="">
          <v-row dense>
            <v-col cols="6" class="text-left">国内諸経費</v-col>
            <v-col cols="6" class="text-right">{{ printDomestic }}</v-col>
          </v-row>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item class="">
          <v-row dense>
            <v-col cols="6" class="text-left">その他</v-col>
            <v-col cols="6" class="text-right">{{ printOthers }}</v-col>
          </v-row>
        </v-list-item>
        <v-divider></v-divider>
      </v-list>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'BilleaderModalConfirmLayout',
  props: [
    'item'
  ],
  data () {
    return {
      form: {}
    }
  },
  mounted () {
    // this.init()
  },
  methods: {
    init: function () {
      if (this.$props.item) {
        const { dates, charges } = this.$props.item
        this.$set(this, 'form', {
          dates: {
            due: (dates && dates.due) ? dates.due : '',
            charged: (dates && dates.charged) ? dates.charged : ''
          },
          charges: {
            school: (charges && charges.school) ? charges.school : '',
            stay: (charges && charges.stay) ? charges.stay : '',
            flight: (charges && charges.flight) ? charges.flight : '',
            insurance: (charges && charges.insurance) ? charges.insurance : '',
            visa: (charges && charges.visa) ? charges.visa : '',
            support: (charges && charges.support) ? charges.support : '',
            domestic: (charges && charges.domestic) ? charges.domestic : '',
            others: (charges && charges.others) ? charges.others : '',
            total: (charges && charges.total) ? charges.total : ''
          }
        })
      }
    }
  },
  computed: {
    printDue () {
      const { dates } = this.$props.item || {}
      return (dates && dates.due) ? this.$moment(dates.due).format('YYYY/MM/DD') : ''
    },
    printCharged () {
      const { dates } = this.$props.item || {}
      return (dates && dates.charged) ? this.$moment(dates.charged).format('YYYY/MM/DD') : ''
    },
    printSchool () {
      const { charges } = this.$props.item || {}
      return (charges && charges.school) ? `¥${charges.school}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : '¥0'
    },
    printStay () {
      const { charges } = this.$props.item || {}
      return (charges && charges.stay) ? `¥${charges.stay}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : '¥0'
    },
    printFlight () {
      const { charges } = this.$props.item || {}
      return (charges && charges.flight) ? `¥${charges.flight}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : '¥0'
    },
    printInsurance () {
      const { charges } = this.$props.item || {}
      return (charges && charges.insurance) ? `¥${charges.insurance}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : '¥0'
    },
    printVisa () {
      const { charges } = this.$props.item || {}
      return (charges && charges.visa) ? `¥${charges.visa}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : '¥0'
    },
    printSupport () {
      const { charges } = this.$props.item || {}
      return (charges && charges.support) ? `¥${charges.support}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : '¥0'
    },
    printDomestic () {
      const { charges } = this.$props.item || {}
      return (charges && charges.domestic) ? `¥${charges.domestic}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : '¥0'
    },
    printOthers () {
      const { charges } = this.$props.item || {}
      return (charges && charges.others) ? `¥${charges.others}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : '¥0'
    },
    printTotal () {
      const { charges } = this.$props.item || {}
      return (charges && charges.total) ? `¥${charges.total}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : '¥0'
    }
  }
}
</script>